import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/Switching/pro-max-16-poe@2x.jpg";
import v3Image from "../../assets/Switching/professionalMax16PoE.jpg";
import type { Product } from "../../types";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professionalMax16PoE: Product = {
  id: "professionalMax16PoE",
  productTitle: "Pro Max 16 PoE",
  description: "professionalMax16PoE.description",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-max-16-poe"],
  storePathParts: {
    productSlug: "usw-pro-max-16-poe",
    category: UniFiChildCategorySlug.SwitchingProfessionalMaxXg,
  },
  sku: "USW-Pro-Max-16-PoE",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 294,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  notes: ["professionalMax16PoE.notes"],
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '325.1 x 160 x 43.7 mm\n(12.8 x 6.3 x 1.7")',
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "16 + 2 SFP+" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: {
        type: "translation",
        value: "commons.speed.upTo2_5Gbps",
      },
    },
    {
      propertyId: uplinkSpeed.id,
      value: {
        type: "string",
        value: "10 Gbps",
      },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: {
        type: "translation",
        value: "professionalMax16PoE.poeAvailability",
      },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "professionalMax16PoE.mounting",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
  ],
};
